import apiAxios from 'helpers/apiAxios';

// Trigger a browser download for a Blob (e.g. a server-generated .xlsx).
export const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

const escape = (v) => `"${String(v ?? '').replace(/"/g, '""')}"`;

export const downloadCsv = (rows, filename) => {
  const headers = [
    'Q/J Number', 'Project Name', 'Customer', 'Sales Incharge', 'Sales Unit',
    'Status', 'Pipeline Value (USD)', 'Weight (MT)', 'Country', 'Location',
    'From Lead', 'Created At'
  ];

  const lines = [
    headers.map(escape).join(','),
    ...rows.map(r => [
      r.j_number || r.q_number || '',
      r.name || '',
      r.company_name || '',
      r.sales_incharge || '',
      r.sales_unit_name || '',
      r.sales_pipeline_name || '',
      r.amount || 0,
      r.weight || 0,
      r.pj_country || '',
      r.pj_location || '',
      r.from_lead ? 'Yes' : 'No',
      r.created_at || ''
    ].map(escape).join(','))
  ];

  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement('a');
  a.href     = url;
  a.download = filename || `sales_records_${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(url);
};

/**
 * Fetches all pages from get_detailed_data server-side (respects backend 200/page cap)
 * and returns the combined rows array.
 *
 * @param {object} params   – base + extra query params (date range, filters, etc.)
 * @param {number} pageSize – records per request (max 200, server enforces this)
 * @param {function} onProgress – optional (current, total) => void callback
 */
export const fetchAllDetailedRows = async (params, pageSize = 200, onProgress = null) => {
  const first = await apiAxios.get('/crm/dashboard/sales/get_detailed_data', {
    params: { ...params, pagination: { page: 1, per_page: pageSize } }
  });

  const pagination  = first.data?.pagination || {};
  const totalPages  = pagination.total_pages  || 1;
  const allRows     = [...(first.data?.data   || [])];

  onProgress?.(1, totalPages);

  for (let pg = 2; pg <= totalPages; pg++) {
    const res = await apiAxios.get('/crm/dashboard/sales/get_detailed_data', {
      params: { ...params, pagination: { page: pg, per_page: pageSize } }
    });
    allRows.push(...(res.data?.data || []));
    onProgress?.(pg, totalPages);
  }

  return allRows;
};
